import {keepPreviousData, queryOptions} from "@tanstack/react-query";

import * as apiClient from "@/lib/api";
import {TopRatedAdvisersCountData} from "@/lib/types/top-rated-advisers-count";
import {QUERY_KEY_TOP_RATED_ADVISERS_COUNT_DATA} from "@/utils/keys";

function fetchTopRatedAdvisersCount(guideYear: number): Promise<TopRatedAdvisersCountData> {
  return apiClient.get(`/firm/top-rated-advisers-count?guideYear=${guideYear}`)
}

export const topRatedAdvisersCountQueryOptions = (guideYear: number) => queryOptions({
  queryKey: [QUERY_KEY_TOP_RATED_ADVISERS_COUNT_DATA, guideYear],
  queryFn: () => fetchTopRatedAdvisersCount(guideYear),
  placeholderData: keepPreviousData
})
